import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  PerplayLogApi,
  LogControllerDtoInventoryTransactionLogListRequest,
  LogControllerDtoItemTransactionLogListRequest
} from '../../models/src';
import {
  inventoryTransactionLogList,
  setInventoryTransactionLogPagination,
  setTotalCount
} from '../../actions/log/inventoryTransactionLogActions';
import {
  INVENTORY_TRANSACTIONLOG_LIST_REQUEST,
  ITEM_TRANSACTION_LOG_LIST_REQUEST
} from '../../constants/log/inventoryTransactionLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoInventoryTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoInventoryTransactionLogListResponse';
import LogControllerDtoItemTransactionLogListResponse
  from '../../models/src/model/LogControllerDtoItemTransactionLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* inventoryTransactionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoInventoryTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.transactionType = payload.transactionType;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogInventoryTransactionLogListPost({ logControllerDtoInventoryTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoInventoryTransactionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(inventoryTransactionLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(setInventoryTransactionLogPagination(
      payload.page,
      data.totalCount,
      payload.beginDate,
      payload.endDate,
      payload.searchCode,
      payload.searchString,
    ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* itemTransactionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoItemTransactionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.transactionType = payload.transactionType;
    requestData.itemId = payload.itemId;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogItemTransactionLogListPost({ logControllerDtoItemTransactionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoItemTransactionLogListResponse);

    if (data.resultCode !== 200) {
      console.log(data);
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    console.log(e);
    payload.error(e);
  }
}

function* inventoryTransactionLogRootSaga() {
  yield all([
    takeEvery(INVENTORY_TRANSACTIONLOG_LIST_REQUEST, inventoryTransactionLogListRequestSaga),
    takeEvery(ITEM_TRANSACTION_LOG_LIST_REQUEST, itemTransactionLogListRequestSaga),
  ])
}

const inventoryTransactionLogSagas = [
  fork(inventoryTransactionLogRootSaga),
];

export default inventoryTransactionLogSagas;
